import StoneList from "../models/stone/StoneList";
import StoneDetail from '../models/stone/StoneDetail'
import Stone from '../models/stone/Stone.vue'
const stoneRouter = {
  path: "/stones",
  name: "Stone",
  component: Stone,
  redirect: "list",
  children: [
    {
      path: "/list",
      name: "StoneList",
      component: StoneList,
      meta: {
        requiresAuth: false,
      }
    },
    {
      path: '/detail/:id(\\d+)',
      name: "StoneDetail",
      component: StoneDetail,
      props: true,
      meta: {
        requiresAuth: false,
      },
      // params: {id: item.productId}}
    }
  ]
};

export default stoneRouter;